import { DatePicker } from "antd";
import { useEffect, useState } from "react";
import { Button, Col, Form, Row } from "react-bootstrap";
import { Controller, useForm } from "react-hook-form";
import { useDispatch, useSelector } from "react-redux";
import ReactSelect from "react-select";
import Swal from "sweetalert2";
import { emptyOption } from "../../../constants";
import { getConvEstado, getTipoRetiro } from "../../../redux/Sections/Convenios/actions";
import { selectStyles } from "../../Select/styles";
import Select from "../../Select";
import { getAbogados } from "../../../redux/Sections/Abogados/actions";
import { formatDate2, formatNewDate2 } from "../../../utils/utils";
import { useUser } from "../../../hooks/useUser";

import "./ConveniosFilter.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEraser } from "@fortawesome/free-solid-svg-icons";


const ConveniosFilter = ({ showFilter, setShowFilter, action, setShowTable, setFilters, planDePago }) => {
  const { abogadosList } = useSelector(e => e.dashboard);
  const dispatch = useDispatch();
  const user = useUser();

  const {
    register,
    handleSubmit,
    control,
    reset
  } = useForm({});
  const [tags, setTags] = useState({});
  const { tiposRetiro, convEstados } = useSelector(e => e.dashboard);
  const [retiro, setRetiro] = useState({});

  const [date, setDate] = useState({
    desde: "",
    hasta: ""
  });
  const [dateMoment, setDateMoment] = useState({
    desde: "",
    hasta: ""
  });

  const [abogado, setAbogado] = useState("");

  useEffect(() => {
    dispatch(getTipoRetiro());
    dispatch(getConvEstado());
    dispatch(getAbogados());
  }, []);

  const onSubmit = (data) => {
    data.desde = date.desde;
    data.hasta = date.hasta;

    setTags(data);

    for (const value in data) {
      if (!data[value] && !(value === "est_retiro" && data[value] === 0)) {
        delete data[value];
      }
    }

    if ((data.est_retiro || data.est_retiro === 0) && Object.keys(data).length === 1) {
      return Swal.fire({
        icon: "warning",
        title: "Error",
        text: "No puede buscar solo por Estado del plan de pago, por favor ingrese otro dato.",
      });
    }

    if (data.nombre) {
      data.nombre = data.nombre.toUpperCase();
    }

    if (user.rol === "user") {
      data.abogado = user.abogado;
    }

    action(data);
    setFilters(data);
    setShowFilter(false);
    setShowTable(true);
  };


  function handleDesde(e) {
    setDateMoment({
      ...dateMoment,
      desde: e
    });
    setDate({
      ...date,
      desde: formatNewDate2(new Date(e))
    });
  }

  function handleHasta(e) {
    setDateMoment({
      ...dateMoment,
      hasta: e
    });
    setDate({
      ...date,
      hasta: formatNewDate2(new Date(e))
    });
  }

  const handleClean = () => {
    reset({});
    setTags({});
    setRetiro({});
    setAbogado("");
    setDate({
      desde: "",
      hasta: ""
    });
    setDateMoment({
      desde: "",
      hasta: ""
    });
  };


  return (
    <div className="filter-container" >
      {showFilter ? (
        <Form onSubmit={handleSubmit(onSubmit)} >
          <div>
            <div style={{ paddingLeft: 15, marginTop: 30, marginBottom: 10, textTransform: "uppercase" }}>Datos del convenio:</div>
            <Row className="mt-3">
              <Col className="col-auto" sm={12} md={6}>
                <Form.Label className="mb-2">N° Convenio</Form.Label>
                <Form.Control
                  name="convenio"
                  {...register("convenio")}
                />
              </Col>

              {
                planDePago ? (
                  <Col sm={12} md={6} >
                    <Form.Label className="mb-2">Número de plan</Form.Label>
                    <Form.Control
                      name="plan"
                      {...register("plan")}
                    />
                  </Col>
                ) : null}
            </Row>

            <Row className="mt-3">
              <Col className="col-auto" sm={12} md={6}>
                <Form.Label className="mb-2">N° imponible</Form.Label>
                <Form.Control
                  name="imponible"
                  {...register("imponible")}
                />
              </Col>
              <Col className="col-auto" sm={12} md={6}>
                <Form.Label className="mb-2">Recurso</Form.Label>
                <Form.Control
                  name="recurso"
                  {...register("recurso")}
                />
              </Col>
            </Row>

            <Row className="mt-3">
              {/* <Col className="col-auto" sm={12} md={6}>
                <Form.Label className="mb-2">Estado de gestión</Form.Label>
                <Controller
                  name="est_gestion"
                  control={control}
                  render={({ field: { onChange } }) => {
                    return (
                      <ReactSelect
                        options={convEstados?.length ? [emptyOption, ...convEstados] : [emptyOption]}
                        onChange={(e) => {
                          setEstadoGestion(e);
                          return onChange(e?.value);
                        }}
                        value={estadoGestion?.value ? estadoGestion : ""}
                        styles={selectStyles}
                      />
                    );
                  }}
                />
              </Col> */}

              <Col className="col-auto" sm={12} md={6}>
                <Form.Label className="mb-2">Estado del plan de pago</Form.Label>
                <Controller
                  name="est_retiro"
                  control={control}
                  render={({ field: { onChange } }) => {
                    return (
                      <ReactSelect
                        options={tiposRetiro?.length ? [emptyOption, ...tiposRetiro] : [emptyOption]}
                        onChange={(e) => {
                          setRetiro(e);
                          return onChange(e?.value);
                        }}
                        value={retiro.label ? retiro : ""}
                        styles={selectStyles}
                      />
                    );
                  }}
                />
              </Col>
            </Row>

            {user?.rol === "admin" || user?.rol === "guest" ? (
              <Row className="mt-3">
                <Col sm={12} md={4}>
                  <Form.Label className="mb-2">Abogado</Form.Label>
                  <Controller
                    name="abogado"
                    control={control}
                    render={({ field: { onChange } }) => {
                      let options = abogadosList?.length ? abogadosList.map(e => {
                        return {
                          ...e,
                          value: e.codexterno,
                          label: `${e.apellido} ${e.nombre}`
                        };
                      }) : [];

                      return (
                        <Select
                          options={options?.length ? [emptyOption, ...options] : [emptyOption]}
                          onChange={(e) => {
                            setAbogado(e);
                            return onChange(e.value);
                          }}
                          value={abogado}
                        />
                      );
                    }}
                  />
                </Col>
              </Row>
            ) : null}

            <Row className="mt-3">
              <Col className="col-dates col-auto" sm={12} md={6}>
                <Form.Label className="label-date mb-2">Desde Fecha</Form.Label>
                <Controller
                  name="desde"
                  control={control}
                  render={({ field: { onChange } }) => {
                    return (
                      <DatePicker
                        className="input-date"
                        placeholder="Seleccione una fecha"
                        format="YYYY-MM-DD"
                        onChange={(e) => {
                          handleDesde(e);
                          return onChange(e);
                        }}
                        value={dateMoment.desde}
                      />
                    );
                  }}
                />
              </Col>
              <Col className="col-dates col-auto" sm={12} md={6}>
                <Form.Label className="label-date mb-2">Hasta Fecha</Form.Label>
                <Controller
                  name="hasta"
                  control={control}
                  render={({ field: { onChange } }) => {
                    return (
                      <DatePicker
                        className="input-date"
                        placeholder="Seleccione una fecha"
                        format="YYYY-MM-DD"
                        onChange={(e) => {
                          handleHasta(e);
                          return onChange(e);
                        }}
                        value={dateMoment.hasta}
                      />
                    );
                  }}
                />
              </Col>
            </Row>
            <Row className="mt-3">
              <Col className="col-auto" sm={12} md={6}>
                <Form.Label className="mb-2">Dirección</Form.Label>
                <Form.Control
                  name="direccion"
                  {...register("direccion")}
                />
              </Col>
            </Row>
          </div>
          <div>
            <div style={{ paddingLeft: 15, marginTop: 30, marginBottom: 10, textTransform: "uppercase" }}>Datos del firmante:</div>
            <Row>
              <Col className="col-auto" sm={12} md={6}>
                <Form.Label className="mb-2">DNI</Form.Label>
                <Form.Control
                  name="dni"
                  {...register("dni")}
                />
              </Col>
              <Col className="col-auto" sm={12} md={6}>
                <Form.Label className="mb-2">Nombre</Form.Label>
                <Form.Control
                  name="nombre"
                  {...register("nombre")}
                />
              </Col>
            </Row>
          </div>

          <Row className=" d-flex justify-content-end" >
            <Col style={{ maxWidth: 122 }}>
              <Button
                type="button"
                variant="danger"
                onClick={handleClean}
                className="danger-button d-flex align-items-center"
              >
                <FontAwesomeIcon icon={faEraser} size="1x" /><span className="ml-2">LIMPIAR</span>
              </Button>
            </Col>
            <Col style={{ maxWidth: 122 }}>
              <Button
                type="submit"
                className="custom-button"
              >
                BUSCAR
              </Button>
            </Col>
          </Row>
        </Form>
      ) : null}
      <>
        {
          <Row className="d-flex justify-content-start mt-4" style={{ paddingLeft: 15 }}>
            <div className="filterby">
              <h5 style={{ marginTop: "2px", fontWeight: 700 }} >Filtrado por:</h5>
            </div>
            {!Object.values(tags).filter((e) => e !== "").length && (
              <div className="tags">
                <span
                  key="sinopciones"
                >
                  No hay opciones seleccionadas
                </span>
              </div>
            )}

            {tags?.convenio ? (
              <div className="tags">
                <span key="convenio" >
                  N° de convenio : {tags.convenio}
                </span>
              </div>
            ) : ""}

            {tags?.direccion ? (
              <div className="tags">
                <span color="green" key="direccion">
                  Dirección : {tags.direccion}
                </span>
              </div>
            ) : ""}

            {tags?.imponible ? (
              <div className="tags">
                <span color="green" key="imponible">
                  N° imponible : {tags.imponible}
                </span>
              </div>
            ) : ""}

            {tags?.recurso ? (
              <div className="tags">
                <span color="green" key="recurso">
                  Recurso : {tags.recurso}
                </span>
              </div>
            ) : ""}

            {tags?.est_gestion ? (
              <div className="tags">
                <span color="green" key="est_gestion">
                  Estado de gestión : {convEstados?.find((e) => e.value === tags?.est_gestion).label}
                </span>
              </div>
            ) : ""}

            {tags?.est_retiro || tags?.est_retiro === 0 ? (
              <div className="tags">
                <span color="green" key="est_retiro">
                  Estado del plan de pago : {tiposRetiro?.find((e) => e.value === tags?.est_retiro).label}
                </span>
              </div>
            ) : ""}

            {tags?.abogado ? (
              <div className="tags">
                <span color="green" key="abogado">
                  Abogado : {tags.abogado}
                </span>
              </div>
            ) : ""}

            {tags?.desde ? (
              <div className="tags">
                <span color="green" key="desde">
                  Desde Fecha : {formatDate2(tags.desde)}
                </span>
              </div>
            ) : ""}

            {tags.hasta ? (
              <div className="tags">
                <span color="green" key="hasta">
                  Hasta Fecha : {formatDate2(tags.hasta)}
                </span>
              </div>
            ) : ""}

            {tags.dni ? (
              <div className="tags">
                <span color="green" key="dni">
                  DNI : {tags.dni}
                </span>
              </div>
            ) : ""}

            {tags.nombre ? (
              <div className="tags">
                <span color="green" key="nombre">
                  Nombre : {tags.nombre}
                </span>
              </div>
            ) : ""}

            {tags.plan ? (
              <div className="tags">
                <span color="green" key="plan">
                  Nro de plan : {tags.plan}
                </span>
              </div>
            ) : ""}

          </Row>
        }
      </>
    </div>
  );
};


export default ConveniosFilter;